import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Snowfall from 'react-snowfall';
import FlowKraftWebsite from './FlowKraftWebsite';
import DeveloppementWeb from './pages/DeveloppementWeb';
import DeveloppementMobile from './pages/DeveloppementMobile';
import DesignUXUI from './pages/DesignUXUI';
import MarketingDigital from './pages/MarketingDigital';
import Consulting from './pages/Consulting';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import CGV from './pages/CGV';
import './index.css';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Effet de neige décoratif */}
        <Snowfall
          color="#A897BD"
          snowflakeCount={50}
          speed={[0.5, 1.0]}
          wind={[-0.5, 0.5]}
          radius={[0.5, 2.0]}
          style={{
            position: 'fixed',
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            pointerEvents: 'none'
          }}
        />
        <Routes>
          <Route path="/" element={<FlowKraftWebsite />} />
          <Route path="/services/developpement-web" element={<DeveloppementWeb />} />
          <Route path="/services/developpement-mobile" element={<DeveloppementMobile />} />
          <Route path="/services/design-ux-ui" element={<DesignUXUI />} />
          <Route path="/services/marketing-digital" element={<MarketingDigital />} />
          <Route path="/services/consulting" element={<Consulting />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cgv" element={<CGV />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
